import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2022 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Head of Networks & Cybersecurity</h3>
            <h4 className="vertical-timeline-element-subtitle">Sana'a, Yemen</h4>
           <ul>
  <li>Lead multi-branch enterprise WAN & Data Center security infrastructure</li>
  <li>Architect and operate NGFW clusters (FortiGate, Sophos, Cisco)</li>
  <li>Design & implement segmentation models for HQ, branches & DR sites</li>
  <li>Deploy SD-WAN connectivity and ZTNA initiatives</li>
  <li>Oversee virtualization & HCI platforms</li>
  <li>Direct Incident Response & DR/BCP programs</li>
  <li>Maintain uptime SLA compliance and incident response procedures</li>
</ul>

          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2021 - 2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Network & System Administrator</h3>
            <h4 className="vertical-timeline-element-subtitle">Sana'a, Yemen</h4>
           <ul>
  <li>Designed campus LAN/WAN architecture</li>
  <li>Implemented firewall segmentation and secure routing</li>
  <li>Deployed VMware virtualization and DNS/DHCP services</li>
  <li>Designed and implemented segmentation across HQ, Data Center & DR facilities</li>
</ul>

          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2019 - 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Network & System Administrator </h3>
            <h4 className="vertical-timeline-element-subtitle">Sana'a, Yemen</h4>
            <ul>
  <li>Design segmentation across HQ, branches and VPN connectivity</li>
  <li>Implemented firewall segmentation and secure routing</li>
  <li>Deployed VMware virtualization and DNS/DHCP services</li>
  <li>Designed and managed branch network communications</li>
  <li>Secured point-of-sale and server environments</li>
</ul>

          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2018 - 2019"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Technical Support and Network Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Sana'a, Yemen</h4>
            <ul>
  <li>Managed and troubleshot network infrastructure including servers, switches, modems, and NVRs</li>
  <li>Maintained PCs, printers, and surveillance systems</li>
  <li>Installed and configured Windows OS and Microsoft Office</li>
  <li>Deployed and administered 3CX PBX VoIP system</li>
  <li>Configured site-to-site VPNs between HQ and branches</li>
</ul>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;